import * as React from "react";

import Link from "@mui/material/Link";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { AmbientScribeNotification } from "services/types/notifications";

const AmbientScribeNotificationComponent = ({
  title,
  description,
  extra
}: AmbientScribeNotification) => {
  return (
    <ListItemText
      primary={title}
      secondary={
        <Stack component="span" gap={1}>
          <Typography component="span">{description}</Typography>
          <Link
            href={`/patients/${extra.patient_id}/chart-notes`}
            underline="hover"
          >
            Open Chart Notes
          </Link>
        </Stack>
      }
    />
  );
};

export default AmbientScribeNotificationComponent;
